<template>
    <VueFinalModal
            class="modal"
            content-class="modal-content"
            overlay-transition="vfm-fade"
            :clickToClose="false"
            @opened="clearSelection"
            @click-outside="emit('close')">
            
        <TeamMemberForm :user="props.user" :only-local-users="!props.asLeader"></TeamMemberForm>

        <div class="modal-container">
            <div class="label-row">
              <label>As Leader</label>
              <input type="checkbox" v-model="props.asLeader"/>
            </div>
            <button class="accent" @click="emit('close')">Cancel</button>
            <button class="accent" @click="saveClicked" :disabled="!enableAddButton()">{{ props.buttonCaption }}</button>
        </div>
    </VueFinalModal>
</template>

<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal';
import TeamMemberForm from '../forms/TeamMemberForm.vue';
import { UserItem } from '@/services/entities/UserItem';
import { reactive } from 'vue';

const props = reactive({
    user: {} as UserItem,
    buttonCaption: 'Add Member',
    clearSelection: true,
    asLeader: false,
});
const emit = defineEmits(["close", "save"]);

function saveClicked() {
  emit('save', props.user, props.asLeader);
}

function clearSelection() {
  if (props.clearSelection) props.user = {} as UserItem;
}

function enableAddButton(): boolean {
  return props.user.id != null && props.user.id.length > 0;
}

</script>

<style lang="scss" scoped>
.modal-container {
  display: flex;
  padding-right: 16px;
  padding-bottom: 16px;
  justify-content: flex-end;
  flex-direction: row;
  button {
    margin-right: 24px;
  }
.label-row {
  display: flex;
  flex-direction: row;
  padding-right: 48px;
  label {
    padding-right: 16px;
    padding-top: 10px;
  }
}
}
</style>